<div class="actionwrapper">
    <div class="actions">
        <button mat-raised-button color="primary" (click)="addItem()">
            <mat-icon>add</mat-icon>
            Add New Vendor Config
        </button>
    </div>
</div>
<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="vendorSlug">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor slug</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.vendorSlug}}</td>
  </ng-container>
  <ng-container matColumnDef="adapterType">
    <th mat-header-cell *matHeaderCellDef>Adapter</th>
    <td class="cell" mat-cell *matCellDef="let item">{{getAdapterTypeLabel(item)}}</td>
  </ng-container>
  <ng-container matColumnDef="credentialConfiguration">
    <th mat-header-cell *matHeaderCellDef>Credential status</th>
    <td class="cell" mat-cell *matCellDef="let item">{{getCredentialStatusLabel(item)}}</td>
  </ng-container>
  <ng-container matColumnDef="requiredFields">
    <th mat-header-cell *matHeaderCellDef>Required fields</th>
    <td class="cell required-fields-cell" mat-cell *matCellDef="let item">
      <ng-container *ngIf="getRequiredFieldSections(item) as sections">
        <ng-container *ngIf="sections.length; else noRequiredFields">
          <div class="required-field-section" *ngFor="let section of sections">
            <span class="required-field-label">{{section.label}}:</span>
            <span>{{section.values.join(', ')}}</span>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #noRequiredFields>
        <span class="empty-required-fields">None</span>
      </ng-template>
    </td>
  </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
      <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-item="item">
        <button mat-menu-item *ngIf="canEditVendor(item)" (click)="editItem(item)">Edit</button>
        <button mat-menu-item *ngIf="canCloneVendor(item)" (click)="addItem(item)">Clone</button>
        <button mat-menu-item *ngIf="canDeleteVendor(item)" (click)="deleteItem(item)">Delete</button>
        <mat-divider></mat-divider>
        <button mat-menu-item *ngIf="hasVendorSchedule(item, 'enroll')" (click)="runScheduleNow(item, 'enroll')">Run Enroll Schedule Now</button>
        <button mat-menu-item *ngIf="hasVendorSchedule(item, 'payment')" (click)="runScheduleNow(item, 'payment')">Run Payment Schedule Now</button>
        <button mat-menu-item (click)="rerunCarrierIntegration(item)">Rerun Carrier Integration</button>
      </ng-template>
    </mat-menu>
</table>
